import { ReceiptsAction, SET_RECEIPTS, SET_RECEIPTS_LOADING, SET_SKIPPED_RECEIPTS } from '@Actions/receiptsActions';

import { IReceiptWithGroupId } from '@ClientServices/receipts';

interface IReceiptsState {
  receipts: IReceiptWithGroupId[];
  receiptsLoading: boolean;
  receiptsLoaded: boolean; // To distinguish between situations where 1) we haven't loaded receipts, vs. 2) we've loaded receipts but the user has 0 receipts

  skippedReceipts: IReceiptWithGroupId[];
}

const defaultState: IReceiptsState = {
  receipts: [],
  receiptsLoading: false,
  receiptsLoaded: false,

  skippedReceipts: []
};

export function receiptsReducer(state = defaultState, action: ReceiptsAction): IReceiptsState {
  switch (action.type) {
    case SET_RECEIPTS: {
      return {
        ...state,
        receiptsLoading: false,
        receiptsLoaded: true,
        receipts: action.payload.map(function (receipt) {
          return {
            ...receipt,
            receiptGroupId: receipt.email_receipt_parent_id || receipt.id
          };
        })
      };
    }
    case SET_RECEIPTS_LOADING: {
      return { ...state, receiptsLoading: action.payload };
    }
    case SET_SKIPPED_RECEIPTS: {
      return {
        ...state,
        skippedReceipts: action.payload.map(function (receipt) {
          return {
            ...receipt,
            receiptGroupId: receipt.email_receipt_parent_id || receipt.id
          };
        })
      };
    }
    default:
      return state;
  }
}
